export default "__VITE_ASSET__bcZbyFmp__"